import { useTextes } from '@common/config';
import { useOrganismeDetailsContext } from '@common/contexts';
import {
  EtablissementDeclarantDto,
  OrganismeStatutEtapier,
  StatutDeclaration,
  useGetAllOrganismeEtablissementsDeclarantsQuery,
} from '@common/services';
import { getModalById } from '@common/ui';
import React from 'react';
import { GenerateDeclarationModal } from '../../../../MyOfa/modals/GenerateDeclarationModal';
import { StepStatus } from '../types/enums/step-status.enum';
import { StepBloc } from './common/StepBloc';

const generateDeclarationModal = getModalById('generate-declaration-modal');

export const Step4Declaration = () => {
  const t = useTextes('ParcoursOfa', 'EtapierStep4');
  const { id, statutEtapier } = useOrganismeDetailsContext();

  const {
    data: etablissementsDeclarants = [] as EtablissementDeclarantDto[],
    isLoading,
  } = useGetAllOrganismeEtablissementsDeclarantsQuery({ id });
  if (isLoading) return;

  const declarationsDownloadedCount = etablissementsDeclarants.reduce((acc, { statutDeclaration }) => {
    if (statutDeclaration && statutDeclaration != StatutDeclaration.NON_TELECHARGEE) acc++;
    return acc;
  }, 0);

  const declarantsCount = etablissementsDeclarants.length;

  const status: StepStatus = (statutEtapier < OrganismeStatutEtapier.ETAPE_4) ? StepStatus.NEXT // "à venir" si l'étape 2 n'est pas validé
    : (statutEtapier === OrganismeStatutEtapier.ETAPE_4 && declarationsDownloadedCount === 0) ? StepStatus.NEW // "nouveau" si aucune déclaration n'est générée
      : (statutEtapier === OrganismeStatutEtapier.ETAPE_4 && declarationsDownloadedCount < declarantsCount) ? StepStatus.PROGRESS // "en cours" si au moins une déclaration est générée
        : StepStatus.DONE;

  return (
    <div>
      <StepBloc status={status}
                disabled={status === StepStatus.NEXT}
                title={t['ETAPE4_TEXTE1']}
                description={t['ETAPE4_TEXTE2']}
                buttons={(status === StepStatus.NEXT) ? [] : [
                  {
                    label: 'Générer',
                    onClick: () => generateDeclarationModal.open(),
                    priority: 'primary',
                  },
                ]} />

      <GenerateDeclarationModal dsfrModal={generateDeclarationModal}
                                etablissements={etablissementsDeclarants} />
    </div>
  );
};